export default __webpack_public_path__ + "static/media/text-bg.ac3e69f0.jpg";